<template>
    <a
        :href="props.url"
        download
        target="_blank"
        class="
            my-2
            gap-1
            p-4
            bg-gray-100
            rounded-md
            inline-flex
            items-center
            justify-center
            flex-col
            hover:bg-gray-200
        "
        v-if="!isVideo && !isImage"
    >
        <ion-icon
            class="text-[48px] text-gray-500"
            name="document-attach-outline"
        ></ion-icon>
        <div>{{ props.attachment.name }}</div>
        <div class="text-xs text-opacity-50">
            {{ attachment.size / 1000 }} KB
        </div>
    </a>
    <div
        class="
            my-2
            gap-1
            p-4
            bg-gray-100
            rounded-md
            inline-flex
            items-center
            justify-center
            flex-col
            hover:bg-gray-200
        "
        v-if="isVideo || isImage"
    >
        <img
            :src="props.thumbnail"
            alt="Preview"
            class="aspect-square object-cover rounded cursor-pointer"
            :style="`max-width: min(${width}px, 100%); width: ${width}px`"
            v-if="isImage"
            @click="state.isImageOpen = true"
        />
        <div :style="`width: ${width}px;max-width:max-content;`" v-if="isVideo">
            <VideoPlayer
                :thumbnail="props.thumbnail"
                :url="props.url"
                v-if="isVideo"
            ></VideoPlayer>
        </div>
    </div>

    <Teleport to="body">
        <div
            v-if="state.isImageOpen"
            class="
                bg-black bg-opacity-75
                fixed
                top-0
                left-0
                w-full
                h-full
                z-[1000]
                flex
                items-center
                justify-center
                modal-open-image
            "
            @click.self="state.isImageOpen = false"
        >
            <img :src="props.url" alt="Preview" />
        </div>
    </Teleport>
</template>

<script setup>
import { computed, reactive } from "vue";
const props = defineProps(["attachment", "url", "thumbnail", "width"]);
const width = props.width ?? 200;
const state = reactive({
    isImageOpen: false,
});

const videoexts = ["mp4", "mov", "mkv", "webm"];
const imageexts = ["png", "jpg", "jpeg", "gif", "svg", "webp"];

const isVideo = computed(() => {
    const extension = props.url.split(".").pop();
    return props.attachment.type === "video" || videoexts.includes(extension);
});

const isImage = computed(() => {
    const extension = props.url.split(".").pop();
    return props.attachment.type === "image" || imageexts.includes(extension);
});
</script>
